import { useEffect, useState } from "react";
import { useQuery } from "react-query";
import { useParams, useNavigate } from "react-router-dom";
import { toast } from "react-toastify";

import useAPI from "../../../hooks/useAPI";
import { GlobalQueries } from "../../../hooks/useRefreshQuery";
import ProfilePage from "../ProfilePage";
import CreateForm from "components/Form/CreateForm/CreateForm";
import Buttons from "components/Buttons/Buttons/Buttons";
import Button from "components/Buttons/Button/Button";
import formFields from "./formFields.json";
import { useTranslation } from "react-i18next";
import { printError } from "../../../helpers/apiError";
import Empty from "components/Empty/Empty";

const AddressPage = () => {
    const navigate = useNavigate();
    const { t } = useTranslation();
    const api = useAPI();
    const apiPath = "profile/company/shipping-address";
    const { id } = useParams();

    // Load all notifications
    const { data, isLoading } = useQuery([GlobalQueries.Profile.Address], () => api.get(`${apiPath}/${id}`));
    const { data: config, isLoading: isConfigLoading } = useQuery(["companyDeliveryAdressConfig"], () => api.get("/options/profile-page/company-delivery-addresses/config"));

    // Local state for the addresses
    const [address, setAddress] = useState({});
    useEffect(() => {
        setAddress(data ?? {});
    }, [data, setAddress]);

    const [loading, setLoading] = useState(false);

    const [updatedFormFields, setUpdatedFormFields] = useState(formFields);
    const [updateFormFields, setUpdateFormFields] = useState(1);

    useEffect(() => {
        const getTownById = async () => {
            const data = await api
                .get(`/profile/company/shipping-address/ddl/id_town?id_country=${address?.id_country}`)
                .then((response) => {
                    return response;
                })
                .catch((error) => {});

            const idTownElementIndex = formFields.findIndex((item) => item.field === "id_town");
            if (idTownElementIndex === -1) return;
            const updatedForm = [...formFields];

            if (data?.length > 1) {
                updatedForm[idTownElementIndex] = {
                    ...updatedForm[idTownElementIndex],
                    options: data,
                    type: "select",
                    columns: 6,
                    field: "id_town",
                };
            } else if (data?.length === 1) {
                updatedForm[idTownElementIndex] = {
                    ...updatedForm[idTownElementIndex],
                    type: "text",
                    options: {},
                    columns: 3,
                    field: "town_name",
                };

                const zipCodeExists = updatedForm.some((item) => item.field === "zip_code");
                if (!zipCodeExists) {
                    const zipCodeField = {
                        field: "zip_code",
                        label: "company_profile-seat-form-field-postal_code-label",
                        placeholder: "",
                        type: "text",
                        rows: false,
                        required: true,
                        disabled: false,
                        columns: 3,
                    };

                    updatedForm.splice(idTownElementIndex + 1, 0, zipCodeField);
                }
            }

            setUpdatedFormFields(updatedForm);
            setUpdateFormFields((prev) => prev + 1);
        };

        if (address?.id_country) getTownById();
    }, [address?.id_country]);

    const submitHandler = () => {
        setLoading(true);
        api.post(apiPath, address)
            .then((response) => {
                toast.success(response?.message ? response?.message : t("global-message-successfully_changed"));
                setAddress(response);
                navigate("/nalog/adrese");
                setLoading(false);
            })
            .catch((error) => {
                setLoading(false);
                toast.warn(printError(error) ? printError(error) : t("global-message-unknown_error"));
            });
    };

    const handlerUpdatedAddress = (getUpdatedField) => {
        const updatedField = getUpdatedField();

        if (updatedField.id_country) {
            setAddress({ ...address, ...updatedField, zip_code: null, town_name: null, id_town: null });
        } else {
            setAddress({ ...address, ...updatedField });
        }
    };

    let renderModul = false;
    if (data && config && config?.active === "1") {
        if (id === "new" && config.user_can_add_company_address_data === "1") {
            renderModul = true;
        } else if (id !== "new" && config.user_can_edit_company_address_data === "1") {
            renderModul = true;
        }
    }

    return (
        <ProfilePage>
            <h4 className="h-underline">{address?.id != null ? address?.name : t("address_profile-default-enter_new_address")}</h4>

            {!renderModul && !isConfigLoading && !isLoading && <Empty message={t("global-module_locked-title")} />}

            {renderModul && (
                <>
                    <Buttons align="right">
                        <Button label={t("global-default-text-Back")} to={"/nalog/adrese"} />
                    </Buttons>
                    <CreateForm
                        loading={loading}
                        data={address}
                        setData={handlerUpdatedAddress}
                        formFields={updatedFormFields}
                        updateFormFields={updateFormFields}
                        submit={{ label: "address_profile-default-form-button-submit", action: submitHandler }}
                        formButtons={(id !== "new" && config?.user_can_edit_company_address_data === "1") || (id === "new" && config?.user_can_add_company_address_data === "1") ? true : false}
                    />
                </>
            )}
        </ProfilePage>
    );
};

export default AddressPage;
